export const stripThinkingBlocks = (text: string): string => {
  if (typeof text !== 'string') return text;
  return text.replace(/<think>[\s\S]*?<\/think>\s*/g, '').trim();
};
